export enum QueryPartEnum {
  JsonAppliedGivens = 'JsonAppliedGivens',
  MalloyQuery = 'MalloyQuery',
  MalloyCompiledQuery = 'MalloyCompiledQuery',
  JsonStoreRequestParts = 'JsonStoreRequestParts',
  JavascriptStoreRequestFunction = 'JavascriptStoreRequestFunction',
  SqlMalloy = 'SqlMalloy',
  SqlMain = 'SqlMain',
  YamlTile = 'YamlTile',
  YamlModel = 'YamlModel',
  MalloySource = 'MalloySource',
  YamlStore = 'YamlStore',
  JsonResults = 'JsonResults'
}
